export const ORDR_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "noteDateTime", "noteInfo", "private" ]
        } ],
        "columns" : [ {
            "name" : "by",
            "title" : "By"
        }, {
            "name" : "noteDateTime",
            "title" : "At"
        }, {
            "name" : "noteInfo",
            "title" : "Info"
        }, {
            "name" : "private",
            "title" : "Internal Note (Not Printed)"
        } ],
        "formName" : "OrderNotes",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"details",
            title:"Details",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "by",
                    "title" : "By"
                }, {
                    "name" : "noteDateTime",
                    "title" : "At"
                }
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "by",
            "description" : "",
            "style" : "",
            "id" : "OrderNotes_by",
            "title" : "By",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "noteDateTime",
            "description" : "",
            "style" : "",
            "id" : "OrderNotes_noteDateTime",
            "title" : "At",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "noteInfo",
            "description" : "",
            "style" : "",
            "id" : "OrderNotes_noteInfo",
            "title" : "Info",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Make Public",
            "title" : "Internal Note (Not Printed)",
            "type" : "HYPERLINK",
            "target" : "updateOrderNote",
            "name" : "private",
            "width" : "",
            "parameterList" : [ {
            "name" : "orderId"
            }, {
            "name" : "noteId"
            }, {
            "name" : "internalNote",
            "value" : {
                "chars" : "N",
                "hint" : 20,
                "empty" : false,
                "original" : "N"
            }
            } ],
            "style" : "",
            "id" : "OrderNotes_private",
            "imageTitle" : "",
            "parameterMap" : {
            "orderId" : "WSCO10731",
            "internalNote" : "N"
            },
            "height" : ""
        } ],
        "target" : ""

    }
]
